import { useCallback, useContext } from 'react'
import { UgeArtboardContext } from '../../contexts/artboard'
import { UgeLayersContext } from '../../contexts/layers'
import { Layer } from '../../types'
import Buttons from './buttons'
import { Container, EndTime, StartTime } from './style'

type Props = {
    className?: string
    disabled?: boolean
    layer: Layer
}

const UgeLayerActions = ({ className, disabled = false, layer }: Props) => {
    const { duration } = useContext(UgeArtboardContext)
    const { updateLayer } = useContext(UgeLayersContext)
    const {
        id,
        props: { timing = { start: 0, end: duration } },
    } = layer

    const onStartTimeChange = useCallback(
        (start: number) => {
            updateLayer(id, { timing: { ...timing, start } })
        },
        [id, timing.end]
    )

    const onEndTimeChange = useCallback(
        (end: number) => {
            updateLayer(id, { timing: { ...timing, end } })
        },
        [id, timing.start]
    )

    return (
        <Container className={className}>
            <StartTime
                disabled={disabled || !duration}
                format="time"
                max={timing.end}
                min={0}
                placeholder="--:--"
                step={0.1}
                value={timing.start}
                onChange={onStartTimeChange}
            />
            <Buttons disabled={disabled} layer={layer} />
            <EndTime
                disabled={disabled || !duration}
                format="time"
                max={duration}
                min={timing.start}
                placeholder="--:--"
                step={0.1}
                value={timing.end}
                onChange={onEndTimeChange}
            />
        </Container>
    )
}

export default UgeLayerActions
